export enum CompanyHintType {
  Common = 1,
  Script = 2,
  ScriptCard = 3,
}
